import { defineStore } from 'pinia';
import { subscribe } from '@nextcloud/event-bus';
import Vue from 'vue';
export const usePathsStore = function () {
    const store = defineStore('paths', {
        state: () => ({
            paths: {}
        }),
        getters: {
            getPath: (state) => {
                return (service, path) => {
                    if (!state.paths[service]) {
                        return undefined;
                    }
                    return state.paths[service][path];
                };
            },
        },
        actions: {
            addPath(payload) {
                // If it doesn't exists, init the service state
                if (!this.paths[payload.service]) {
                    Vue.set(this.paths, payload.service, {});
                }
                // Now we can set the provided path
                Vue.set(this.paths[payload.service], payload.path, payload.fileid);
            },
        }
    });
    const pathsStore = store(...arguments);
    // Make sure we only register the listeners once
    if (!pathsStore._initialized) {
        // TODO: watch folders to update paths?
        // subscribe('files:node:created', pathsStore.onCreatedNode)
        // subscribe('files:node:deleted', pathsStore.onDeletedNode)
        // subscribe('files:node:moved', pathsStore.onMovedNode)
        pathsStore._initialized = true;
    }
    return pathsStore;
};
